import React, { useContext } from "react";
import styled from "styled-components";
import {
  space,
  SpaceProps,
  layout,
  LayoutProps,
  display,
  PositionProps,
  DisplayProps,
  position,
} from "styled-system";
import { ThemeContext } from "styled-components";

interface StyledProps
  extends SpaceProps,
    LayoutProps,
    PositionProps,
    DisplayProps {
  fill?: string;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
  ${position}
`;

const PrintSVG: React.FunctionComponent<StyledProps> = ({
  fill = "black",
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const color = theme.colors[fill] || fill;

  return (
    <StyledContainer {...props}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-icon="ban"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        height="100%"
        width="100%"
        fill={color}
      >
        <title>Print options</title>
        <path d="M400 264c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm32-88V99.88c0-12.73-5.06-24.94-14.06-33.94l-51.88-51.88c-9-9-21.21-14.06-33.94-14.06H110.48C93.64 0 80 14.33 80 32v144c-44.18 0-80 35.82-80 80v128c0 8.84 7.16 16 16 16h64v96c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-96h64c8.84 0 16-7.16 16-16V256c0-44.18-35.82-80-80-80zM128 48h192v48c0 8.84 7.16 16 16 16h48v64H128V48zm256 416H128v-64h256v64zm80-112H48v-96c0-17.64 14.36-32 32-32h352c17.64 0 32 14.36 32 32v96z"></path>
      </svg>
    </StyledContainer>
  );
};

export default PrintSVG;
